var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAdministracion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21020",
    "data-name": "Grupo 21020",
    transform: "translate(-1344 -397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_2069",
    "data-name": "Rect\\xE1ngulo 2069",
    transform: "translate(1344 397)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gear-svgrepo-com",
    transform: "translate(1345.832 399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27716",
    "data-name": "Trazado 27716",
    d: "M19.112,14.056A5.056,5.056,0,1,1,14.056,9,5.056,5.056,0,0,1,19.112,14.056Z",
    transform: "translate(4.112 4.112)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27717",
    "data-name": "Trazado 27717",
    d: "M19.693,3.1A5.744,5.744,0,0,0,18.168,3a5.744,5.744,0,0,0-1.525.1,2.528,2.528,0,0,0-1.282.868,5.742,5.742,0,0,0-.66,1.378,2.132,2.132,0,0,1-2.653,1.231l-.962-.321A5.66,5.66,0,0,0,9.728,5.9a2.528,2.528,0,0,0-1.407.332,5.66,5.66,0,0,0-1.053.93,5.718,5.718,0,0,0-.983,1.119,2.528,2.528,0,0,0-.306,1.489,5.718,5.718,0,0,0,.462,1.416,2.439,2.439,0,0,1-1.01,3l-.468.281a5.578,5.578,0,0,0-1.334.94,2.528,2.528,0,0,0-.51.9A5.645,5.645,0,0,0,3,17.943a5.8,5.8,0,0,0,.159,1.925,2.529,2.529,0,0,0,.668.987,5.732,5.732,0,0,0,1.715.858,1.908,1.908,0,0,1,1.1,2.375l-.363,1.088a5.653,5.653,0,0,0-.388,1.5,2.527,2.527,0,0,0,.3,1.278,5.65,5.65,0,0,0,1.018,1.168,5.657,5.657,0,0,0,1.168,1.018,2.527,2.527,0,0,0,1.278.3,5.658,5.658,0,0,0,1.5-.388l.888-.3A2.132,2.132,0,0,1,14.7,30.989a5.744,5.744,0,0,0,.66,1.378,2.529,2.529,0,0,0,1.282.868,5.749,5.749,0,0,0,1.525.1,5.749,5.749,0,0,0,1.525-.1,2.529,2.529,0,0,0,1.282-.868,5.745,5.745,0,0,0,.66-1.378,2.131,2.131,0,0,1,2.653-1.23l.887.3a5.659,5.659,0,0,0,1.5.388,2.528,2.528,0,0,0,1.278-.3,5.655,5.655,0,0,0,1.168-1.018,5.656,5.656,0,0,0,1.018-1.168,2.528,2.528,0,0,0,.3-1.278,5.659,5.659,0,0,0-.388-1.5l-.362-1.087a1.909,1.909,0,0,1,1.1-2.376,5.735,5.735,0,0,0,1.715-.858,2.529,2.529,0,0,0,.668-.987,5.8,5.8,0,0,0,.159-1.925,5.644,5.644,0,0,0-.12-1.64,2.529,2.529,0,0,0-.51-.9,5.581,5.581,0,0,0-1.334-.94l-.468-.281a2.439,2.439,0,0,1-1.01-3,5.72,5.72,0,0,0,.462-1.416,2.528,2.528,0,0,0-.306-1.489,5.717,5.717,0,0,0-.983-1.119,5.664,5.664,0,0,0-1.053-.93A2.528,2.528,0,0,0,26.607,5.9a5.66,5.66,0,0,0-1.358.361l-.961.32a2.132,2.132,0,0,1-2.653-1.231,5.742,5.742,0,0,0-.66-1.378A2.528,2.528,0,0,0,19.693,3.1Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdministracion);
export default __webpack_public_path__ + "static/media/icon-administracion.1fed83b779b85c11d26562acab3b67d5.svg";
export { ForwardRef as ReactComponent };